"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassifyModal = void 0;
const react_1 = __importStar(require("react"));
const predicate_language_1 = require("@groupby/predicate-language");
const ui_components_1 = require("@groupby/ui-components");
const icons_material_1 = require("@mui/icons-material");
const debounce_1 = __importDefault(require("debounce"));
const breadcrumbs_component_1 = require("./breadcrumbs/breadcrumbs.component");
const classify_modal_styles_1 = require("./classify-modal.styles");
const product_list_component_1 = require("./product-list.component");
const search_component_1 = require("./search/search.component");
const constants_1 = require("../../../../constants");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const highlighted_1 = __importDefault(require("../../../components/highlighted"));
const nodes_tree_context_1 = require("../../../contexts/nodes-tree.context");
const hooks_2 = require("../../../hooks");
const selectors_1 = require("../../../../store/selectors");
const utils_1 = require("../../../../utils");
const ClassifyModal = ({ isOpen, onClassify, onClose, selectedProductsCount, activeFilter, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addError, addSuccess } = (0, hooks_1.useNotification)();
    const isExclusionModeOn = (0, selectors_1.useIsExclusionModeOn)();
    const selectedProductIds = (0, selectors_1.useSelectedProductIds)();
    const loadRefinements = (0, hooks_2.useRefinements)();
    const client = (0, hooks_1.useEnrichClient)();
    const { nodesTree } = (0, react_1.useContext)(nodes_tree_context_1.NodesTreeContext);
    const [selectedNodeId, setSelectedNodeId] = (0, react_1.useState)(null);
    const [currentNode, setCurrentNode] = (0, react_1.useState)(null);
    const [taxonomyNodes, setTaxonomyNodes] = (0, react_1.useState)();
    const [searchQuery, setSearchQuery] = (0, react_1.useState)('');
    const [expanded, setExpanded] = (0, react_1.useState)(true);
    const [listExpanded, setListExpanded] = (0, react_1.useState)([]);
    const initialTaxonomyNodes = (0, react_1.useRef)(null);
    const taxonomyNodesMap = (0, react_1.useMemo)(() => { var _a; return new Map((_a = taxonomyNodes === null || taxonomyNodes === void 0 ? void 0 : taxonomyNodes.map((item) => [item.id, item])) !== null && _a !== void 0 ? _a : []); }, [taxonomyNodes]);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            setTaxonomyNodes(Array.from(nodesTree.values()));
            initialTaxonomyNodes.current = nodesTree;
        }
    }, [isOpen]);
    const handleTreeSearch = (0, react_1.useCallback)((0, debounce_1.default)((query) => {
        const updatedTree = (0, utils_1.buildTreeFromFilteredItems)(initialTaxonomyNodes.current, query);
        setTaxonomyNodes(Array.from(updatedTree.values()));
        if (!query) {
            setListExpanded([]);
            return;
        }
        const nodeIds = (0, utils_1.getNodeIds)(updatedTree);
        setListExpanded(nodeIds);
    }, constants_1.SEARCH_QUERY_UPDATE_DELAY), []);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = initialTaxonomyNodes.current) === null || _a === void 0 ? void 0 : _a.size) {
            handleTreeSearch(searchQuery);
        }
    }, [handleTreeSearch, searchQuery]);
    (0, react_1.useEffect)(() => {
        if (!isOpen) {
            setSelectedNodeId(null);
            setSearchQuery('');
        }
    }, [isOpen]);
    const selectedNode = (0, react_1.useMemo)(() => (selectedNodeId ? (0, utils_1.findTreeItemById)(taxonomyNodesMap, selectedNodeId) : null), [selectedNodeId, taxonomyNodesMap]);
    const handleProceedButtonClick = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const classId = (selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.classId) || null;
            if (isExclusionModeOn) {
                const filter = (0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '!@<', selectedProductIds.map(predicate_language_1.uuid)).and(activeFilter);
                const result = yield client.products.updateMacro({ classId }, filter);
                addSuccess(t({ key: 'CLASSIFY_PRODUCTS_SUCCESS', values: { count: result } }));
            }
            else {
                const updatedProducts = selectedProductIds.map((id) => ({ id, classId }));
                const products = yield client.products.updateMany(updatedProducts);
                addSuccess(t({ key: 'CLASSIFY_PRODUCTS_SUCCESS', values: { count: products.length } }));
            }
            void loadRefinements();
            void onClassify();
        }
        catch (_a) {
            addError(t({ key: 'CLASSIFY_PRODUCTS_ERROR' }));
        }
        finally {
            onClose();
        }
    }), [
        selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.classId,
        isExclusionModeOn,
        loadRefinements,
        onClassify,
        selectedProductIds,
        activeFilter,
        client.products,
        addSuccess,
        t,
        addError,
        onClose,
    ]);
    const handleTreeNodeSelect = (0, react_1.useCallback)((_, nodeId) => {
        if (!nodeId) {
            setCurrentNode(null);
            setSelectedNodeId(null);
            return;
        }
        const node = (0, utils_1.findTreeItemById)(taxonomyNodesMap, nodeId);
        if (!node.children.size) {
            setCurrentNode(node);
            setSelectedNodeId(nodeId);
        }
        else {
            setCurrentNode(null);
        }
    }, [taxonomyNodesMap]);
    const handleTreeNodeEnter = (0, react_1.useCallback)((nodeId) => {
        const node = (0, utils_1.findTreeItemById)(taxonomyNodesMap, nodeId);
        if (!node.children.size) {
            setCurrentNode(node);
        }
        else {
            setCurrentNode(null);
        }
    }, [taxonomyNodesMap]);
    const handleKeyDown = (0, react_1.useCallback)((e, nodeId) => {
        e.stopPropagation();
        if (e.keyCode === 38 || e.keyCode === 40) {
            handleTreeNodeEnter(nodeId);
        }
    }, [handleTreeNodeEnter]);
    const renderTreeNode = (0, react_1.useCallback)((taxonomyNode) => (react_1.default.createElement(classify_modal_styles_1.StyledTreeItem, { key: taxonomyNode.id, itemId: taxonomyNode.id, slots: { expandIcon: icons_material_1.ChevronRight, collapseIcon: icons_material_1.ExpandMore }, slotProps: {
            expandIcon: { color: 'primary' },
            collapseIcon: { color: 'primary' },
        }, label: react_1.default.createElement(highlighted_1.default, { text: taxonomyNode.title, query: searchQuery }), onMouseEnter: () => handleTreeNodeEnter(taxonomyNode.id), onKeyUp: (e) => handleKeyDown(e, taxonomyNode.id), onMouseLeave: () => setCurrentNode(null), "$hasChildren": taxonomyNode.children.size > 0 }, taxonomyNode.children.size ? [...taxonomyNode.children.values()].map((child) => renderTreeNode(child)) : null)), [handleKeyDown, handleTreeNodeEnter, searchQuery]);
    const renderedTreeNodes = (0, react_1.useMemo)(() => (taxonomyNodes ? taxonomyNodes === null || taxonomyNodes === void 0 ? void 0 : taxonomyNodes.map(renderTreeNode) : []), [renderTreeNode, taxonomyNodes]);
    const handleToggle = (_, itemIds) => {
        setListExpanded(itemIds);
    };
    return (react_1.default.createElement(ui_components_1.Dialog, { maxWidth: 'md', open: isOpen, title: react_1.default.createElement(classify_modal_styles_1.StyledTitle, null, t({ key: 'CLASSIFY_MODAL_TITLE' })), proceedButtonProps: {
            title: t({ key: 'CLASSIFY' }),
            onClick: handleProceedButtonClick,
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: onClose,
        } }, react_1.default.createElement(product_list_component_1.ProductList, { expanded: expanded, setExpanded: setExpanded, productsCount: selectedProductsCount, activeFilter: activeFilter }), react_1.default.createElement(ui_components_1.Box, { display: "flex" }, react_1.default.createElement(classify_modal_styles_1.StyledTreeWrapper, null, react_1.default.createElement(search_component_1.ClassifyModalSearch, { searchQuery: searchQuery, onSearch: setSearchQuery }), react_1.default.createElement(classify_modal_styles_1.StyledTree, { expandedItems: listExpanded, selectedItems: selectedNodeId, onSelectedItemsChange: handleTreeNodeSelect, onExpandedItemsChange: handleToggle, "$productsCount": selectedProductsCount, "$listExpanded": expanded }, renderedTreeNodes)), react_1.default.createElement(classify_modal_styles_1.StyledBox, null, react_1.default.createElement(breadcrumbs_component_1.ClassifyModalBreadCrumbs, { node: currentNode !== null && currentNode !== void 0 ? currentNode : selectedNode, taxonomyNodes: taxonomyNodes, selectedNodeId: selectedNodeId, onClearNode: () => setSelectedNodeId(null) })))));
};
exports.ClassifyModal = ClassifyModal;
exports.default = exports.ClassifyModal;
